import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationSubjectUpdatedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_SUBJECT_UPDATED'>;
};

export const ConversationSubjectUpdated = ({
  entry,
}: ConversationSubjectUpdatedProps): JSX.Element => {
  const { author, old_subject, new_subject } = entry;

  const authorLink = (
    <UserLink userId={author.id}>
      {author.name ?? author.email ?? author.id}
    </UserLink>
  );

  return (
    <LogEntry
      entry={entry}
      icon="pen"
      text={
        <>
          {authorLink} updated subject from &ldquo;{old_subject}&rdquo; to
          &ldquo;{new_subject}&rdquo;
        </>
      }
    />
  );
};
